import { UseCustomAxios } from "../../UseCustomAxios";
import { useSnackbar } from "notistack";
import { isEmpty } from "../../util/Utils";

export function UseConsultation() {
  const MyAxios = UseCustomAxios();
  const { enqueueSnackbar } = useSnackbar();

  function validate(state, setter) {
    let errorState = {
      orderType: isEmpty(state.orderType),
      question: isEmpty(state.question),
    };
    setter(errorState);

    if (errorState.orderType || errorState.question) {
      enqueueSnackbar("لطفا اطلاعات   را کامل وارد کنید", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      return 500;
    } else {
      return 200;
    }
  }

  const GetConsultants = (myPC, search, state, callback, bool) => {
    MyAxios.get(`Admin_Consulate?w=${search}`, {
      headers: {
        IsPage: bool ? true : false,
        Conditions: JSON.stringify({
          state: state == "null" ? null : state,
          pageCondition: myPC,
        }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const GetConsultantById = (consultantId, callback) => {
    MyAxios.get(`Admin_Consulate/${consultantId}`).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const GetOrderById = (consultantId, page, callback) => {
    MyAxios.get(`Admin_Consulate/orders/${consultantId}/${page}`).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          callback(response.data.resault);
        }
      }
    );
  };

  const GetHistoryById = (consultantId, page, callback) => {
    MyAxios.get(`Admin_Consulate/history/${consultantId}/${page}`).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          callback(response.data.resault);
        }
      }
    );
  };

  const confirmConsultant = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.post(`Admin_Consulate/confirm`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("باموفقیت انجام شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const denyConsultant = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.post(`Admin_Consulate/deny`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("باموفقیت انجام شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const suspendConsultant = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.post(`Admin_Consulate/suspend`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("باموفقیت انجام شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  return {
    validate,
    GetConsultants,
    GetConsultantById,
    GetOrderById,
    GetHistoryById,
    confirmConsultant,
    denyConsultant,
    suspendConsultant,
  };
}
